import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginationType } from '../shared/models/pagination.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private apiService: ApiService) {}

  dashboard() {
    return this.apiService.get(`/event/dashboard`);
  }

  filter(model: any) {
    return this.apiService.post('/event/filter', model);
  }

  getDashboardFilter(model: any) {
    return this.apiService.post('/event/dashboard/search-filter', model);
  }

  dashboardFilter(model: any) {
    if (!model.isReNewCache) {
      return this.apiService.post(
        '/admindashboard/stats?isNoLoading=true',
        model
      );
    }
    return this.apiService.post('/admindashboard/stats', model);
  }

  dashboardShiftFilter(
    rosterId: string,
    shiftId: string,
    isReNewCache: boolean = true
  ) {
    if (!isReNewCache)
      return this.apiService.get(
        `/admindashboard/stats/shift/${rosterId}/${shiftId}/${isReNewCache}?isNoLoading=true`
      );

    return this.apiService.get(
      `/admindashboard/stats/shift/${rosterId}/${shiftId}/${isReNewCache}`
    );
  }

  getEvents(keyword: any, type: string, pagination: PaginationType) {
    const model = {
      keyword: keyword,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      type: type,
      sortField: pagination.sortField,
      sortDir: pagination.sortDir
    };
    return this.apiService.post('/event/get-events', model);
  }

  startEvent(eventId: string) {
    return this.apiService.post(`/event/start/${eventId}`);
  }

  getEvent(eventId: string) {
    return this.apiService.get(`/event/get/active/${eventId}`);
  }

  getEventByShiftSnapshot(shiftSnapshotId: string) {
    return this.apiService.get(`/event/get/snapshot/${shiftSnapshotId}`);
  }

  createEvent(model: any) {
    return this.apiService.post('/event/create', model);
  }

  updateEvent(model: any) {
    return this.apiService.post('/event/update', model);
  }

  getActiveEvent() {
    return this.apiService.get('/event/active');
  }

  getActiveEvents() {
    return this.apiService.get('/event/active/list');
  }

  addKnight(eventId: string) {
    return this.apiService.post(`/event/knight/add/${eventId}`);
  }

  addBeaconDeviceSpec(eventId: string, model: any) {
    return this.apiService.post(`/event/create/beacon-device-spec/${eventId}`, model);
  }

  addBeaconDeviceSpecToSnapshot(shiftSnapshotId: string, model: any) {
    return this.apiService.post(`/event/create/beacon-device-spec/snapshot/${shiftSnapshotId}`, model);
  }

  getAvailableBeaconBySnapshot(shiftSnapshotId: string) {
    return this.apiService.get(`/event/beacon/available/${shiftSnapshotId}`);
  }


  addBuildingSpec(eventId: string, model: any) {
    return this.apiService.post(`/event/create/building-spec/${eventId}`, model);
  }

  addKnightToEvent(eventId: string, userId: string) {
    return this.apiService.post(`/event/knight/add/${eventId}/${userId}`);
  }

  removeKnightFromEvent(eventId: string, userId: string) {
    return this.apiService.post(`/event/knight/remove/${eventId}/${userId}`);
  }

  getEventKnights(eventId: string) {
    return this.apiService.get(`/event/knight/get/${eventId}`);
  }

  getEventKnightsLocationLog(eventId: string) {
    return this.apiService.get(`/event/knight/location/${eventId}`);
  }

  logDataEvent(model: any) {
    return this.apiService.post('/event/log', model);
  }

  getEventLogs(eventId: string) {
    return this.apiService.get(`/event/log/${eventId}`);
  }

  getKnightEventLogs(eventId: string) {
    return this.apiService.get(`/event/log/${eventId}/knight`);
  }

  joinEvent() {
    return this.apiService.post(`/event/join`);
  }

  finishEvent(eventId: string) {
    return this.apiService.post(`/event/finish/${eventId}`);
  }

  ping() {
    return this.apiService.get(`/event/ping`);
  }

  getAllActiveKnightLocation() {
    return this.apiService.get(`/event/knight/locations/active`);
  }

  deleteEvent(eventId: string) {
    return this.apiService.post(`/event/delete/${eventId}`);
  }

  updateStatusEvent(eventId: string, status: string) {
    return this.apiService.post(`/event/status/${eventId}/${status}`);
  }

  archiveEvent(eventId: string) {
    return this.apiService.post(`/event/${eventId}/archive`, {});
  }

  getEventStatusCounts(keyword: string = '') {
    const model = { keyword };
    return this.apiService.post('/event/event-status-counts', model);
  }

  getKnightInfo(userId: string) {
    return this.apiService.get(`/event/knight/info/${userId}`);
  }

  getAvailableKnights(eventId: string) {
    return this.apiService.get(`/event/knight/list/available/${eventId}`);
  }

  exportIcsFile() {
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');
    return this.apiService.httpPostDownloadFile(
      '/event/calendar/export/ics',
      null,
      {
        headers: headers,
        reportProgress: true,
        responseType: 'blob',
      }
    );
  }

  importIcsFile(model: any) {
    return this.apiService.post(`/event/calendar/import/ics`, model);
  }

  getKnightInfoList(model: any) {
    return this.apiService.post(`/event/list/knight/info`, model);
  }

  exportKnightData(eventId: string) {
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');
    return this.apiService.httpPostDownloadFile(
      `/event/knight/location/export/${eventId}`,
      null,
      {
        headers: headers,
        reportProgress: true,
        responseType: 'blob',
      }
    );
  }

  addEventShift(model: any) {
    return this.apiService.post(`/event/shift/create`, model);
  }

  updateEventShift(model: any) {
    return this.apiService.post(`/event/shift/update`, model);
  }

  getEventShift(id: string) {
    return this.apiService.get(`/event/shift/${id}`);
  }

  getEventShiftByGroup(groupId: string) {
    return this.apiService.get(`/event/shift/list/${groupId}`);
  }

  getActiveRoster(eventId: string) {
    return this.apiService.get(`/event/active-rosters/shifts/${eventId}`);
  }

  deleteEventShift(id: string) {
    return this.apiService.post(`/event/shift/delete/${id}`);
  }

  getAvailableShiftKnights(shiftId: string) {
    return this.apiService.get(`/event/shift/knight/list/available/${shiftId}`);
  }

  getShiftKnights(shiftId: string) {
    return this.apiService.get(`/event/shift/knight/list/${shiftId}`);
  }

  getShiftKnightsData(shiftId: string, date: string) {
    return this.apiService.get(
      `/event/shift/knight/list-data/${shiftId}/${date}`
    );
  }

  getStaffShiftData(
    shiftId: string,
    rosterId: string,
    staffId: string,
    date: string,
    totalDays: number
  ) {
    return this.apiService.get(
      //`/event/shift/staff-data/${shiftId}/${rosterId}/${staffId}/${date}/${totalDays}`
      `/event/shift/staffs-data/${shiftId}/${rosterId}/${date}/${totalDays}?userId=${staffId}`
    );
  }

  getShiftStaffsData(
    shiftId: string,
    rosterId: string,
    date: string,
    totalDays: number,
    staffId: string = ''
  ) {
    return this.apiService.get(
      `/event/shift/staffs-data/${shiftId}/${rosterId}/${date}/${totalDays}${staffId ? `?userId=${staffId}` : ''}`
    );
  }

  getEventKnightData(eventId: string, date: string) {
    return this.apiService.get(
      `/event/event/knight/list-data/${eventId}/${date}`
    );
  }

  addKnightToShift(shiftId: string, userId: string) {
    return this.apiService.post(`/event/shift/knight/add/${shiftId}/${userId}`);
  }

  removeKnightFromShift(shiftId: string, userId: string) {
    return this.apiService.post(
      `/event/shift/knight/remove/${shiftId}/${userId}`
    );
  }

  // Event Group
  // getEventGroup(id: string) {
  //   return this.apiService.get(`/event/group/${id}`);
  // }

  // addEventGroup(model: any) {
  //   return this.apiService.post(`/event/group/create`, model);
  // }

  // updateEventGroup(model: any) {
  //   return this.apiService.post(`/event/group/update`, model);
  // }

  // deleteEventGroup(id: string) {
  //   return this.apiService.post(`/event/group/delete/${id}`);
  // }
  getEventEmergencyUsers() {
    return this.apiService.get(`/event/emergency/users?isNoLoading=true`);
  }

  checkSiteDelete(id: string) {
    return this.apiService.get(`/event/check-delete/${id}`);
  }

  getClientMirrorUser() {
    return this.apiService.get(`/event/mirror-client`);
  }

  getTimeZone(lat: string, lng: string, timestamp: string) {
    return this.apiService.get(`/event/timezone/${lat}/${lng}/${timestamp}`);
  }

}
